import { Controller } from '@hotwired/stimulus';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class extends Controller {
    // We only need the image target for this effect
    static targets = ['image'];

    connect() {
        // Set the initial scale of the image
        gsap.set(this.imageTarget, {
            scale: 1.4,
        });

        // Animate the image scale as the hero section scrolls into view
        gsap.to(this.imageTarget, {
            scale: 1,
            ease: 'none',
            scrollTrigger: {
                trigger: this.element,
                start: 'top bottom', // Start the animation when the top of the element hits the bottom of the viewport
                end: 'bottom top',   // End the animation when the bottom of the element leaves the top of the viewport
                scrub: true,         // Link the animation directly to the scroll position
            },
        });
    }
}
